import { endorseeColumnConfig, endorseeViewColumnConfig } from './endorseeTableConfig';
import  EndorseeEmailModal from './EndorseeEmailModal';
import { ssSessionUtils, ssDateUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import { Row, Col, Table, Card, Input, Tooltip, Button, Icon } from 'antd';
import EndorseePhotoModal from '@bit/ui-common.ui-components/ss-common-data/react/components/endoresments/EndorseePhotoModal';
import moment from 'moment';
const
{ unixSecondsToDateString } = ssDateUtils,
{ fileDownloadWithPost, setEnvPrefix } = ssCommonUtils,
{ isDod } = ssSessionUtils,
{ Search } = Input;
export default class extends React.Component {
    state = {
        endorsementData: null,
        fullResults: null,
        searchResults: null,
        emailModal: false,
        title: {
            searchText: '',
            hasSearch: false
        },
        dodPhotoModal: false,
        photoClickTime: 0,
        endorsementId: null,
        userName: null,
        page: 1,
        pageSize: 10,
        tableSearch: ''
    }

    
    
    constructor(props) { super(props); }
    getEndorseeHover = (uploadUser, photoCreateDate, photoName, photoMimeType, image, comments, displayImage) => (
        <div>
                    <Row>
                        <Col span={8}>
                            {'Uploaded By:'}
                        </Col>
                        <Col span={16}>
                            {uploadUser}
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8}>
                            {'Uploaded On:'}
                        </Col>
                        <Col span={16}>
                            {photoCreateDate}
                        </Col>
                    </Row>
                    
                    <Row>
                    <Col span={8}>
                            {'Image Name:'}
                        </Col>
                        <Col span={16}>
                            {photoName}
                        </Col>
                    </Row>
                    <Row>
                    <Col span={8}>
                            {'Image Type'}
                        </Col>
                        <Col span={16}>
                            {photoMimeType}
                        </Col>
                    </Row>
                    <Row style={{minWidth: '300px'}}>
                        <Col span={8}>
                            {'Comments'}
                        </Col>
                        <Col span={16}>
                            {comments ? comments: '-'}
                        </Col>
                    </Row>
                    {displayImage== 'Y' ? 
                    <Row>
                        <Col>
                            {photoMimeType=='application/pdf' ? <Icon type='file-pdf' style={{fontSize: '72px'}}/> :
                            <img src={`data:${photoMimeType};base64,${image}`} style={{maxWidth: '800px',
                                                                                        maxHeight: '800px'}}/>
                            }
                        </Col>
                    </Row> : null}
        </div>
    );

    componentDidMount(){
        
        this.setState( {fullResults: this.formatData(this.props.data)});
    }

    getStatusButton = (status, id) => (
        <div>{
            status ? (
                <div>
                    <Row type='flex' justify='start' align='middle'>
                        <h4>{'Endorsed'}</h4>
                    </Row>
                    <Row type='flex' justify='start' align='bottom'>
                        <Button
                            id={id}
                            onClick={() => this.toggleModalState(id)}
                            size={'small'}
                            type='danger'
                            ghost='ghost'>{'Cancel'}</Button>
                    </Row>
                </div>
            ) : (
                <Row type='flex' justify='start' align='middle'>
                    <h4>{'Endorsement Cancelled'}</h4>
                </Row>
            )
        }</div>
    )

    getActionButton = (record) => (
        <div onClick={()=> this.handlePhoto(record.endorsementId)}>
        {(record.imgName != undefined) ? 
        <Tooltip title={ record.imgName == 'NoImgComment' ? record.imageComments : () => this.getEndorseeHover(record.uploadUser, unixSecondsToDateString(record.createdDate), record.imgName, record.mimeType, null, record.imageComments, 'N')} 
            overlayStyle={{maxWidth: 'max-content'}}>
            <Icon type='picture'
                style={{ 
                marginRight: '10px',
                fontSize: '22px'
            }}/>
        </Tooltip>
        :
        <Tooltip title={'Please upload a user photo'} 
             color='blue'>
            <Icon type='user'
                style={{ 
                marginRight: '10px',
                fontSize: '22px'
            }}/>
        </Tooltip>
        }
        
        </div>
    )

    getEmailButton = (d) => (
        <div onClick={()=> this.toggleEndorsementEmailModalWithRecord(d)}>
        <Icon type='mail'
            
            style={{ 
            marginRight: '10px',
            fontSize: '22px'
        }}/>
        </div>

    )

    downloadCSV() {
        const { title } = this.state,
            { page, pageSize, sort, column} = this.props.endorsements.pagingData,
            search = title.hasSearch ? title.searchText : "" ;
        
        return {orgIds: window.session.jwtSession.ORGS, page: page, pageSize: pageSize, sort: sort, column: column, search: search};
    }

    toggleModalState(id) {
        const { setEmailEndorsementId, toggleEndorsementRevokeModal, addSearchText } = this.props.services;
        setEmailEndorsementId(id);
        toggleEndorsementRevokeModal();
        if (this.state.title.hasSearch) {
            addSearchText(this.state.title.searchText);
        }
    }
    toggleEndorsementEmailModalWithRecord = d =>  {
        const 
        { endorsements} = this.props,

        { data } = endorsements;
        let endorsementData = null;
        for (let i in data) {
            if (data[i].endorsementId == d.endorsementId) {
                endorsementData = data[i];
                break;
            }
        }
        this.setState({ endorsementData: endorsementData, emailModal: !this.state.emailModal });
            
    }

    toggleEndorsementEmailModal = id => this.setState({
        emailModal: !this.state.emailModal,
        id: id ? id : undefined,
    })
    componentDidUpdate(prevProps){
      if( prevProps.endorsements.loading &&
          !this.props.endorsements.loading ) {
        this.setState( {fullResults: this.formatData(this.props.endorsements.data)});

      }
    }

    formatData(data) {
        const defaultValue = '-';
        return data == null || data.length == undefined || data.length <= 0 ? [] : data.map(d => {
            const
            e = d.person.encounter,
            bio = d.person.applicantBiographicData,
            trainee = `${bio.firstName || ''}${bio.lastName != null ? ` ${bio.lastName}` : ''}`;
            try {
                let p = JSON.parse(d.person.encounterAttributes[0].dataValue);
                return {
                    id: d.endoursmentId,
                    key: d.key,
                    endorsementId: `${d.endorsementId || defaultValue}`,
                    trainee: trainee.length <= 0 ? defaultValue : trainee,
                    provider: `${p.providerName || defaultValue}`,
                    startDate: p.estimatedStartDate != null ? unixSecondsToDateString(parseInt(p.estimatedStartDate)) : defaultValue,
                    endDate: p.estimatedEndDate != null ? unixSecondsToDateString(parseInt(p.estimatedEndDate)) : defaultValue,
                    created: e.timestamp != null ? unixSecondsToDateString(e.timestamp) : defaultValue,
                    status: isDod() ? this.getStatusButton(d.isEndorsed, d.endorsementId) : d.isEndorsed != null ? d.isEndorsed ? 'Active' : 'Cancelled' : defaultValue,
                    dodAction: !isDod() ? this.getActionButton(d) : '-',
                    viewEmail: this.getEmailButton(d),
                    uploadUser: d.uploadUser != null ? d.uploadUser : defaultValue,
                    photoCreateDate: d.createdDate != null ? unixSecondsToDateString(d.createdDate) : defaultValue,
                    photoMimeType: d.mimeType != null ? d.mimeType : defaultValue,
                    photoName: d.imgName != null ? d.imgName: defaultValue,
                    
                    image: d.image != null ? d.image: defaultValue,
                    imageComments: d.imageComments != null ? d.imageComments:defaultValue
                };
            } catch(err) { return {}; }
        });
    }

    handleSearch(data, e) {
        const { endorsements, services } = this.props,
        { title } = this.state,
        { pagingData } = endorsements;

        services.getEndorsementsData(pagingData.page, pagingData.pageSize, pagingData.sort, pagingData.column, e);
        this.setState({...this.state, title: {...title, hasSearch: true }, page: pagingData.page, pageSize: pagingData.pageSize});
    }

    handleSearchText(e) {
        const
        { title } = this.state,
        { value } = e.target;
        this.setState({...this.state, title: {...title, searchText: value }});
    }

    handleSortChange = (pagination, filters, sorter) => {

        const { endorsements, services } = this.props,
            { pagingData } = endorsements,
            { searchText, hasSearch } = this.state.title,
            search = hasSearch ? searchText : '';
  
        if (pagination.current != pagingData.page || pagination.pageSize != pagingData.pageSize) {
            services.handleOnChangePaging(pagination.current, pagination.pageSize, pagingData.sort, pagingData.column);
            services.getEndorsementsData(pagination.current, pagination.pageSize, pagingData.sort, pagingData.column, search);
            this.setState({...this.state, page: pagination.current, pageSize: pagination.pageSize, tableSearch: search})
        } else {
            if (sorter.column) {
                services.handleOnChangePaging(pagination.current, pagination.pageSize, sorter.order, sorter.column.column);
                services.getEndorsementsData(pagination.current, pagination.pageSize, sorter.order, sorter.column.column, search);
                this.setState({...this.state, page: pagination.current, pageSize: pagination.pageSize, tableSearch: search})
            } else {
                services.handleOnChangePaging(pagination.current, pagination.pageSize); 
                services.getEndorsementsData(pagination.current, pagination.pageSize, null, null, search);
                this.setState({...this.state, page: pagination.current, pageSize: pagination.pageSize, tableSearch: search})
            }
        }
      }

    handlePhoto = (endorsementId) => {
        
        const time = moment.utc().unix();
        this.setState({dodPhotoModal: true,  photoClickTime: time, endorsementId: endorsementId});

    }
    render() {
        const
        { endorsements, services, trainingRequestsPhotoUpload, yourAccount} = this.props,
        { userName } = yourAccount,
        { data, pagingData } = endorsements,
        { searchResults, title, fullResults, endorsementData, dodPhotoModal, photoClickTime, endorsementId } = this.state;
        return (
            <div>
                <EndorseeEmailModal endorsementData={endorsementData} toggleEndorsementEmailModal={this.toggleEndorsementEmailModal} showModal={this.state.emailModal} {...this.props} />
                {isDod() ? null :  <EndorseePhotoModal key={photoClickTime} dodPhotoModal={dodPhotoModal} endorsementId={endorsementId} userName={userName} services={services} trainingRequestsPhotoUpload={trainingRequestsPhotoUpload} getEndorseeHover={this.getEndorseeHover} page={this.state.page} pageSize={this.state.pageSize} tableSearch={this.state.tableSearch}/> }
                <Row type='flex' justify='space-around' align='middle'> 
                    <Col span={23}>
                        <div style={{ marginTop: '0px' }}>
                            <Card
                                style={{
                                    overflow: 'hidden',
                                    borderRadius: '4px',
                                    borderStyle: 'none none none solid',
                                    borderWidth: '4px',
                                    borderColor: 'rgb(0, 68, 136)',
                                    boxShadow: 'rgb(150, 150, 150) 0px 0px 20px',
                                    height: '34px'
                                }}
                                bodyStyle={{ padding: '10px 30px 10px 30px' }}
                            >
                                <div className='provider-endorsement-header-search'>
                                    <Row>
                                        <Col span={24}>
                                            <div style={{ display: 'inline-block', width: '250px' }}>
                                                <Search
                                                    size='small'
                                                    enterButton={true}
                                                    placeholder={'Search by Trainee, Provider or ID'}
                                                    onSearch={e => this.handleSearch(fullResults, e)}
                                                    onChange={e => this.handleSearchText(e)}
                                                    style={{ borderRadius: '10px' }}
                                                    value={title.searchText}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div className='provider-endorsement-header-title'>
                                    <span style={{
                                        fontSize: '14px',
                                        fontWeight: 'bold',
                                        fontStyle: 'italic'
                                    }}>
                                        {'DOD Endorsements'}
                                    </span>
                                </div>
                            </Card>
                        </div>
                    </Col>
                </Row>
                { 
                    <Row type='flex' justify='space-around' align='middle'>
                        <Col span={23}>
                            <div className='provider-border-accent provider-table-card'>
                                <Table
                                    size='large'
                                    loading={endorsements.loading}
                                    columns={this.props.yourAccount ? endorseeViewColumnConfig : endorseeColumnConfig}
                                    dataSource={searchResults == null ? fullResults : searchResults}
                                    pagination={{
                                        total: pagingData.total,
                                        showTotal: ( ( total, range ) => `${ range[ 0 ]}-${ range[ 1 ]} of ${ total } items` ),
                                        pageSize: pagingData.pageSize,
                                        current: pagingData.page,
                                        showSizeChanger: true,
                                        pageSizeOptions: ['10', '20', '30', '40', '50']
                                    }}
                                    onChange={this.handleSortChange}
                                    
                                    footer={d => {
                                        return (
                                            <div style={{ margin: '8px 0px', height: '12px' }}>
                                                {!fullResults || fullResults.lenght <= 0 ? null : (
                                                    <Tooltip title='Download CSV file' placement='right'>
                                                        <Button type="default" shape="circle" icon='download' onClick={()=>{fileDownloadWithPost(setEnvPrefix('/afsp-dod/endorsee/file/'), 
                                                                                                                            this.downloadCSV());}}/>
                                                    </Tooltip>
                                                )}
                                            </div>
                                        )
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                }
            </div>
        );
    }
}
